import { render, staticRenderFns } from "./WidgetBase.vue?vue&type=template&id=803918a6&scoped=true"
import script from "./WidgetBase.vue?vue&type=script&lang=js"
export * from "./WidgetBase.vue?vue&type=script&lang=js"
import style0 from "./WidgetBase.vue?vue&type=style&index=0&id=803918a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803918a6",
  null
  
)

export default component.exports